import { ConditionDescription } from 'models';
import { DataAccessObjectType } from './formHelperAdditionalData';

export function conditionDescriptionsToFunction(conditionDescriptions: (ConditionDescription | null)[], dataAccessObject: DataAccessObjectType): Function {
    if (!conditionDescriptions || conditionDescriptions.length === 0) {
        return () => true;
    }

    let conditions = conditionDescriptions.map(x => createCondition(x, dataAccessObject));

    return () => conditions.every(x => x());
}

function createCondition(conditionDescription: ConditionDescription | null, dataAccessObject: DataAccessObjectType): Function {
    if (!conditionDescription) {
        return () => true;
    }

    let keys = Object.keys(conditionDescription.fields);

    const conditionFunction = new Function(...keys, `return \`${conditionDescription.expression}\`;`);

    return () => {
        const values = keys.map(x => dataAccessObject[conditionDescription.fields[x]]());

        let isAnyFieldEmpty = values.includes('' || null);

        if (isAnyFieldEmpty) {
            return false;
        }

        return conditionFunction(...values) === 'true';
    };
}